import React, { useEffect, useState } from 'react'
import ToolCard from 'components/Owner/Tools/ToolCard'
import Button from 'components/Common/Button'

import {
  AllToolsModalBodyStyle,
  AllToolsModalFooterStyle,
  AllToolsModalStyle,
} from 'components/Owner/Tools/style'
import { Tool } from '__generated__/api-types-and-hooks'

export interface IAllToolsModalProps {
  allTools: Tool[]
  setShowModal: (visible: boolean) => void
  getAllToolsAction: (payload?: { tenantId: string }) => void
  updateMyToolsAction: (props: { selectedTools: string }) => void
}

const AllToolsModal = ({
  allTools,
  setShowModal,
  getAllToolsAction,
  updateMyToolsAction,
}: IAllToolsModalProps) => {
  const [selectedTool, setSelectedTool] = useState<any>([])

  useEffect(() => {
    getAllToolsAction()
    // eslint-disable-next-line
  }, [])

  const handleUpdateOwner = () => {
    updateMyToolsAction({ selectedTools: JSON.stringify(selectedTool) })
    setShowModal(false)
  }

  const handleSelectedTool = (id, tool) => {
    if (selectedTool.find((tool) => tool.id === id)) {
      setSelectedTool(selectedTool.filter((tool) => tool.id !== id))
    } else setSelectedTool([...selectedTool, tool])
  }
  return (
    <>
      <AllToolsModalStyle>
        <div className="all-tools-modal-header">
          <div>
            <label className="all-tools-modal-header-title">What tools do you use?</label>
          </div>
          <div className="all-tools-modal-header-label">
            <label>
              Don’t worry about choosing all of the tools you use, just pick a few to get started.
            </label>
          </div>
        </div>
        <div className="xs:block sm:hidden">
          <span>
            <Button label="Done" variant={'primary'} onClick={handleUpdateOwner} />
          </span>
          <span>
            {/* check-button -- clean up custom styles */}
            <Button
              label="Skip"
              variant={'secondary'}
              className="!outline-0 active:outline-0 xs:mt-3 mt-0 focus:border-0 w-full"
              onClick={() => setShowModal(false)}
            />
          </span>
          <hr className="all-tools-modal-header-hr"></hr>
        </div>
        <AllToolsModalBodyStyle>
          <div className="all-tools-modal-box">
            {allTools?.map(
              (tool) =>
                tool.visible && (
                  <ToolCard
                    key={tool.id}
                    tool={tool}
                    selectedTool={selectedTool}
                    handleSelectedTool={handleSelectedTool}
                  />
                )
            )}
          </div>
        </AllToolsModalBodyStyle>
        <AllToolsModalFooterStyle>
          <span className="mr-3">
            <Button label="Skip" variant="secondary" onClick={() => setShowModal(false)} />
          </span>
          <span>
            <Button label="Done" variant="primary" onClick={handleUpdateOwner} />
          </span>
        </AllToolsModalFooterStyle>
      </AllToolsModalStyle>
    </>
  )
}

AllToolsModal.defaultProps = {}

export default AllToolsModal
